import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { AISearchState } from '../type/ai-search.type';
import { TechStep } from '../type/ai-search.enum';

export const AISearchModel = Symbol('AISearchModel');

export interface AISearchModel extends AbstractModel<AISearchState> {}

@injectable()
export class AISearchModelImpl extends AbstractModelImpl<AISearchState> implements AISearchModel {
    protected _modelData: AISearchState = {
        step: TechStep.TECH_DESC,
    };
}
